export function removeProtocol(url: string) {
  const urlObj = new URL(url)
  return urlObj.host + urlObj.pathname + urlObj.search + urlObj.hash
}
